// extracted by mini-css-extract-plugin
export var closeButton = "_mi-2";
export var closeButtonIcon = "_mi-3";
export var lightboxContent = "_mi-1";
export var lightboxOverlay = "_mi-0";